module.exports = __webpack_public_path__ + "static/media/peda_walk.435fba6e.gif";